import { Auth } from "aws-amplify";
import { createBrowserHistory } from "history";
// import "bootstrap/dist/css/bootstrap.min.css";
import { default as React, useEffect, useState } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ReactGA from "react-ga";
import { useIdleTimer } from "react-idle-timer";
import { Router, withRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import PageLoader from "./components/PageLoader";
import ScrollToTop from "./components/ScrollToTop";
import Sidebar from "./components/SideBar";
import config from "./config";
import useAuth from "./contexts/useAuth";
import logo from "./images/logo.png";
import { Constants } from "./libs/Constants";
import { get } from "./libs/dbFunctions";
import Routes from "./Routes";
const history = createBrowserHistory();
const configObj = config.getConfigObject();

if (configObj.googleAnalyticsId) {
  ReactGA.initialize(configObj.googleAnalyticsId);
}

// Initialize google analytics page view tracking
history.listen((location) => {
  if (configObj.googleAnalyticsId) {
    ReactGA.set({ page: location.pathname }); // Update the user's current page
    ReactGA.pageview(location.pathname); // Record a pageview for the given page
  }
});

function App(props) {
  const sessionTimeout = Constants.SESSION_TIMEOUT_IN_HOURS;
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [onBehalf, setOnBehalf] = useState(null);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [sideBar, setSideBar] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const {
    user: loggedInUser,
    setLoggedInUser,
    activeCompany,
    setActiveCompany,
  } = useAuth();
  const { } = useIdleTimer({
    timeout: 1000 * 60 * 60 * sessionTimeout,
    onIdle: () => {
      handleLogout();
    },
    onActive: () => { },
    onAction: () => { },
    debounce: 500,
  });
  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    if (activeCompany) {
      localStorage.setItem("taabl-ac", JSON.stringify(activeCompany));
    }
  }, [activeCompany]);

  async function loadActiveCompany(companyId) {
    // Get it from local storage
    let ac = localStorage.getItem("taabl-ac");
    if (!ac) {
      let c = await get(Constants.dbTypes.COMPANY, companyId);
      localStorage.setItem("taabl-ac", JSON.stringify(c));
      setActiveCompany(c);
    } else {
      setActiveCompany(JSON.parse(ac));
    }
  }
  function showEmployeeView() {
    let o = Object.assign(loggedInUser);
    setOnBehalf(o);
    let userBehalf = Object.assign({}, loggedInUser, {
      permission: Constants.PermissionLevel.EVERYONE,
    });
    // changing user object causes route permissions to redirect the route appropriately
    setLoggedInUser(userBehalf);
    history.push("/");
  }
  function showAdminView() {
    let user = Object.assign(onBehalf);
    setLoggedInUser(user);
    setOnBehalf(null);
    history.push("/");
  }
  async function onLoad() {
    try {
      setPageLoading(true);
      Auth.configure({ storage: sessionStorage });
      await Auth.currentSession();
      let user = await Auth.currentAuthenticatedUser();
      let o = await get(Constants.dbTypes.USER, user.username);
      setLoggedInUser(o);
      await loadActiveCompany(o.companyId);
      userHasAuthenticated(true);
    } catch (e) {
      console.log(e);
    }
    setPageLoading(false);
    setIsAuthenticating(false);
  }

  async function refreshUser() {
    return onLoad();
  }

  function toggleSidebar(e) {
    console.log("Inside toggleSidebar", e);
    setSideBar(e);
  }

  async function handleLogout() {
    await Auth.signOut();
    userHasAuthenticated(false);
    setLoggedInUser(null);
    setActiveCompany(null);
    localStorage.clear();
    history.push("/login");
  }

  let dropdown = <></>;
  let adminDropDown = <></>;
  if (isAuthenticated) {
    if (
      (loggedInUser &&
        loggedInUser.permission !== Constants.PermissionLevel.UNABLE &&
        loggedInUser.permission >= Constants.PermissionLevel.ADMIN) ||
      (onBehalf && onBehalf.permission >= Constants.PermissionLevel.ADMIN)
    ) {
      adminDropDown = (
        <>
          <NavDropdown.Divider />
          {!onBehalf && (
            <NavDropdown.Item onClick={showEmployeeView}>
              Switch To Employee View
            </NavDropdown.Item>
          )}
          {onBehalf && (
            <NavDropdown.Item onClick={showAdminView}>
              Switch To Admin View
            </NavDropdown.Item>
          )}
        </>
      );
    }
    dropdown = (
      <React.Fragment>
        <NavDropdown
          id="menu"
          className="pb-0"
          align="end"
          title={loggedInUser.firstName}
          drop={"down"}
        >
          <NavDropdown.Item href="/settings">Settings</NavDropdown.Item>
          {adminDropDown}
          <NavDropdown.Divider />
          <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
        </NavDropdown>
        <div className="nav-company-name">{activeCompany?.name}</div>
      </React.Fragment>
    );
  }

  // <Navbar fluid collapseOnSelect>
  if (isAuthenticating) {
    return (
      <PageLoader isActive={pageLoading} individual={false}>
        <></>
      </PageLoader>
    );
  }
  const showNav =
    props.location && props.location.pathname !== "/moneycalculator";
  return (
    !isAuthenticating && (
      <Router history={history}>
        <ScrollToTop location={props.location} />

        {showNav && (
          <Navbar
            className="nav-sticky"
            sticky="top"
            expand="sm"
            onToggle={(e) => toggleSidebar(e)}
          >
            {/* <Navbar.Toggle aria-controls="brand-nav-icon" /> */}
            <Navbar.Brand className="me-sm-auto ms-3">
              {/*<Link to="/">TAABL</Link> */}
              {!isAuthenticated && (
                <img
                  src={logo}
                  width="141"
                  height="47"
                  className="d-inline-block align-top"
                />
              )}
            </Navbar.Brand>

            <Nav className="justify-content-end flex-column align-items-end">
              {dropdown}
            </Nav>
          </Navbar>
        )}
        {isAuthenticated && (
          <Sidebar
            location={props.location}
            expand={sideBar}
            handleLogout={handleLogout}
            userObj={loggedInUser}
            activeCompany={activeCompany}
          ></Sidebar>
        )}
        <ToastContainer
          draggable
          pauseOnHover
          hideProgressBar={true}
          style={{ zIndex: 999999 }}
        />

        <Routes
          appProps={{
            isAuthenticated,
            userHasAuthenticated,
            userObj: loggedInUser,
            setUserObj: setLoggedInUser,
            onBehalf,
            setOnBehalf,
            activeCompany,
            setActiveCompany,
            setPageLoading,
            pageLoading,
            refreshUser,
          }}
        />
      </Router>
    )
  );
}

export default withRouter(App);
